<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';

// Component Imports
import CodemirrorModeMenu from '../../common/codemirror/CodemirrorModeMenu';
import CodemirrorLineNumbersBtn from '../../common/codemirror/CodemirrorLineNumbersBtn';
import CodemirrorLineWrappingBtn from '../../common/codemirror/CodemirrorLineWrappingBtn';
import CodemirrorTwigModeBtn from '../../common/codemirror/CodemirrorTwigModeBtn';
import UserName from '../../common/UserName';
import ThemesEditorContentTypeFieldsBtn from './ThemesEditorContentTypeFieldsBtn';
import Button from "../../common/Button.vue";

const props = defineProps({
    editor: {
        type: Object,
        required: true
    },
    saveEditor: {
        type: Function,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const item = ref(null);

// --- Computed ---

const alphaMode = computed(() => store.state.alphaMode);

const showTwigControl = computed(() => {
    return props.editor && props.editor.tableName === 'templates_templates';
});

const isContentType = computed(() => {
    return (
        props.editor &&
        props.editor.tableName === 'templates_templates' &&
        item.value &&
        item.value.type === 'contentType'
    );
});

const modifiedBy = computed(() => {
    if (item.value) {
        return item.value.modifiedBy || item.value.createdBy;
    }
    return null;
});

// --- Async Data Logic (Replaces asyncComputed) ---

watch(() => [props.editor.tableName, props.editor.id], async () => {
    item.value = await store.dispatch('itemData/get', {
        tableName: props.editor.tableName,
        id: props.editor.id
    });
}, { immediate: true });
</script>

<template>
    <div class="d-flex align-items-center small">
        <div class="flex-fill d-flex align-items-center">
            <div class="dropup ms-1 p-1">
                <Button class="btn-sm" data-bs-toggle="dropdown">
                    <i class="bi-three-dots"/>
                </Button>
                <ul class="dropdown-menu" @click.stop>
                    <li class="dropdown-item text-center">
                        <CodemirrorModeMenu/>
                    </li>
                    <CodemirrorLineNumbersBtn/>
                    <CodemirrorLineWrappingBtn/>
                    <CodemirrorTwigModeBtn/>
                </ul>
            </div>

            <ThemesEditorContentTypeFieldsBtn v-if="isContentType" :id="editor.id"/>
        </div>

        <div class="d-flex align-items-center">
            <small class="me-1 text-body-secondary">
                <strong>
                    <Timeago v-if="item" :datetime="(item.modifiedDate || item.createdDate) * 1000"/>
                </strong>
                by
                <strong class="text-secondary">
                    <UserName
                        v-if="modifiedBy"
                        :id="modifiedBy"
                        :no-user-found-str="'user not found'"
                        :no-user-str="'system'"
                    />
                </strong>
            </small>

            <Button
                class="me-1 btn-sm"
                @click.native="saveEditor"
                :active-value="editor.isModified"
                :active-class="'btn-warning'"
            >
                <i class="bi-save"/>
            </Button>
        </div>
    </div>
</template>

<style scoped>
/* Scoped styles preserved empty */
</style>